import { render, staticRenderFns } from "./NewConcessionPermitCard.vue?vue&type=template&id=34422930&scoped=true"
import script from "./NewConcessionPermitCard.vue?vue&type=script&lang=ts"
export * from "./NewConcessionPermitCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34422930",
  null
  
)

export default component.exports